/**
 * Plugins
 */
import Vue from "vue"
import Moment from "moment"
import 'moment/locale/ru'
import VueMoment from "vue-moment"
import Toast from "vue-toastr"
import VueMask from "v-mask"

/**
 * Import own libs
 */
import requestApi from "./libs/requestApi"
import eventBus from "./libs/eventBus"
import storageApi from "./libs/storageApi"

/**
 * Getting root component
 */
import App from "./App.vue"

/**
 * Custom files
 */
import router from "./router"
import store from "./vuex/store"
import Auth from "./vuex/services/auth/actions"

/**
 * Get common files
 */
import "./common/components"
import "./common/httpConfig"
import "./common/filters"

/**
 * "use" plugins
 */
Vue.use(VueMoment, {Moment})
Vue.use(Toast)
Vue.use(VueMask)

/**
 * "use" own libs
 */
Vue.use(requestApi)
Vue.use(eventBus)
Vue.use(storageApi)

/**
 * Connect global component
 */
Vue.component('vue-toast', Toast)

/**
 * Connect styles
 */

require('normalize.css/normalize.css')
require('ionicons/css/ionicons.css')
require('slick-carousel/slick/slick.css')
require("font-awesome/css/font-awesome.css")
require("slick-carousel/slick/slick-theme.css")
require("vue-multiselect/dist/vue-multiselect.min.css")
require("vue-toastr/dist/vue-toastr.min.css")

require("./assets/fonts/calibri/font.css")
require("./assets/css/main.css")
require("./assets/css/media.css")
require("./assets/css/custom-select2.css")
require("./assets/css/hover.css")
require("./assets/css/f-grid.css")
require('./assets/css/datepicker.css')

Vue.config.productionTip = false

let story = null

router.beforeEach((to, from, next) => {
	let pages = ['Login', 'One', 'Two', 'Three', 'Four', 'Main', 'Clinics', 'Doctors', 'SingleClinic', 'SingleDoctor', 'Agreement', 'Offer']

	if (!Auth.checkUser(store) && pages.indexOf(to.name) === -1) {

		story = {
			name: to.name,
			query: to.query,
			params: to.params
		}

		next({name: 'Login'})
		Vue.event.toast('i', "Авторизируйтесь, пожалуйста")
	}

	if (story && Auth.checkUser(store)) {
		let tmp = story
		story = null
		next(tmp)
	}

	next()
})

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App),
	mounted() {
		if (this.$storage.isExist('X-Access-Token')) {
			this.$store.dispatch('auth/getUser')
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js